/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Fachliche Art einer Designvorlage. Steuert, welche Zusatzfunktionen
 * angeboten werden — z.B. erscheint der Vorlagenwechsel unter
 * Anzeige/Aktionen nur bei GRUSSKARTEN. Bewusst ein gepflegtes Merkmal an
 * der Vorlage statt einer Abfrage auf Kategorie oder Namen: Namen aendern
 * sich, Kategorien sind zu grob.
 * 
 * KEINE ist der ausdrueckliche Verzicht. Es braucht diesen Wert, weil der
 * Update-Mapper null ueberspringt (NullValuePropertyMappingStrategy.
 * IGNORE): Ein Leeren des Feldes in der Maske haette die Art sonst still
 * stehen lassen — gespeichert, neu geladen, immer noch da.
 * @export
 */
export const DatabaseArt = {
    Grusskarten: 'GRUSSKARTEN',
    Keine: 'KEINE'
} as const;
export type DatabaseArt = typeof DatabaseArt[keyof typeof DatabaseArt];


export function DatabaseArtFromJSON(json: any): DatabaseArt {
    return DatabaseArtFromJSONTyped(json, false);
}

export function DatabaseArtFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseArt {
    return json as DatabaseArt;
}

export function DatabaseArtToJSON(value?: DatabaseArt | null): any {
    return value as any;
}

